import { Box, Button } from "@mui/material";

import { SubmissionButton } from "@thalamos/frontend";
import { buildTranslationInput } from "@thalamos/vision-common";

import { Translation } from "../../../Translation/Translation.js";
import type { IncidentTableRow } from "../types.js";

/**
 * The cell which renders the action buttons
 */
export function ActionsCell({ row }: { row: IncidentTableRow }) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "0.5rem",
        justifyContent: "flex-end",
        flexWrap: "wrap",
      }}
    >
      {row.secondaryButton && (
        <SubmissionButton
          variant="outlined"
          onClick={async () => {
            await row.secondaryButton?.onClick();
          }}
          sx={{ minWidth: "5rem", flex: "1 0 auto" }}
          data-testid="cancel"
        >
          <Translation {...buildTranslationInput(row.secondaryButton.label)} />
        </SubmissionButton>
      )}
      <Button
        variant="contained"
        onClick={() => {
          void row.primaryButton.onClick();
        }}
        sx={{ minWidth: "5rem", flex: "1 0 auto" }}
        data-testid="viewIncident"
        disabled={row.primaryButton.disabled}
      >
        <Translation {...buildTranslationInput(row.primaryButton.label)} />
      </Button>
    </Box>
  );
}
